import React from 'react';
import cn from 'clsx';
import { css } from 'linaria';
import { createElementKey } from 'utils';
import { Layout } from 'fronton-react';
import { ButtonWithGAClickButton } from '../../../button';
import { stickyBannerActionWrapper, stickyBannerWrapper } from '../../design-registration-panel-styles';
import { PanelActionBlock } from '../mobile-fixed-panel';

export const tabletFixedPanel = css`
  display: none;

  @media (--only-tablet) {
    display: flex;
    padding-top: 8px;
    padding-bottom: 8px;
  }
`;

export const tabletFixedPanelButton = css`
  && {
    @media (--only-tablet) {
      padding: 10px 20px;
      font-size: 14px;
      line-height: 20px;
    }
  }
`;

type TabletFixedPanelProps = {
  actionBlock: PanelActionBlock[];
};

export const TabletFixedPanel = ({ actionBlock }: TabletFixedPanelProps) => (
  <Layout className={cn(stickyBannerWrapper, tabletFixedPanel)}>
    <div className={stickyBannerActionWrapper}>
      {actionBlock.map(({ label, onClick, shortLabel, ...btnProps }, index: number) => (
        <ButtonWithGAClickButton
          aria-label={label}
          className={tabletFixedPanelButton}
          elementName={label}
          elementText="sticky-panel"
          onClick={onClick}
          key={createElementKey('panel-btn', index)}
          title={label}
          {...(btnProps as Omit<PanelActionBlock, 'label' | 'onClick'>)}>
          {label}
        </ButtonWithGAClickButton>
      ))}
    </div>
  </Layout>
);
